import { render, staticRenderFns } from "./KPAModal.vue?vue&type=template&id=c374c70a&scoped=true"
import script from "./KPAModal.vue?vue&type=script&lang=js"
export * from "./KPAModal.vue?vue&type=script&lang=js"
import style0 from "./KPAModal.vue?vue&type=style&index=0&id=c374c70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c374c70a",
  null
  
)

export default component.exports